export default __webpack_public_path__ + "images/MM.e319df4.png";